import { takeLatest, put } from 'redux-saga/effects'
import { Toaster } from '@blueprintjs/core'
import { createReducer, makeAction, makeKeys } from './reduxHelpers'
import { httpGet } from 'core/restClient'
import { setUserAdmin } from './authen'
import { menus } from 'variables/menus'

let toast = Toaster.create({ message: '', show: false })

const INITIALIZE = makeKeys('INITIALIZE')
const APP_LOADING = 'APP_LOADING'
const APP_LOADED = 'APP_LOADED'
const TOAST_SUCCESS = 'TOAST_SUCCESS'
const TOAST_WARNING = 'TOAST_WARNING'
const TOAST_ERROR = 'TOAST_ERROR'
const SHOW_SIDE_MENU = 'SHOW_SIDE_MENU'
const COLLAPSE_MENU = 'COLLAPSE_MENU'
const COLLAPSE_SUB_MENU = 'COLLAPSE_SUB_MENU'
const SHOW_MODAL = 'SHOW_MODAL'
const SHOW_CONFIRM_MODAL = 'SHOW_CONFIRM_MODAL'
const SET_SHOW_MOBILE_MENU = 'SET_SHOW_MOBILE_MENU'

export const initialize = makeAction(INITIALIZE.REQUEST, 'history')
export const appLoading = makeAction(APP_LOADING, 'message')
export const appLoaded = makeAction(APP_LOADED)
export const toastSuccess = makeAction(TOAST_SUCCESS, 'message')
export const toastWarning = makeAction(TOAST_WARNING, 'message')
export const toastError = makeAction(TOAST_ERROR, 'message','isNoTimeout')
export const showSideMenu = makeAction(SHOW_SIDE_MENU)
export const collapseSideMenu = makeAction(COLLAPSE_MENU)
export const collapseSubMenu = makeAction(COLLAPSE_SUB_MENU, 'index', 'subIndex')
export const showModal = makeAction(SHOW_MODAL, 'show', 'header', 'message', 'size')
export const showConfirmModal = makeAction(SHOW_CONFIRM_MODAL, 'show', 'data') 
export const setShowMobileMenu = makeAction(SET_SHOW_MOBILE_MENU, 'show') 

const initializeSuccess = makeAction(INITIALIZE.SUCCESS)
const initializeFailure = makeAction(INITIALIZE.FAILURE)

const initial = {
  showSideMenu: true,
  collapseSideMenu: false,
  loading: false,
  menus: menus,
  user: {
    id:'',
    name: '',
    username: '', 
    email: '', 
    token: '', 
    tokenExpire: '',
    roles:[]
  },
  modal: {
    show: false,
    header: '',
    message: '',
    size: 'small'
  },
  confirmModal: {
    show: false,
    data: {
      header: '',
      message: '',
      btnConfirmText: 'Confirm',
      onClickConfirm: () => {},
      btnCancelText: 'Cancel',
      onClickCancel: () => {},
    }
  },
  showMobileMenu: false
}

function* initializeApplication(action) {
  const { history } = action.payload
  try {
    const response = yield httpGet('authen/validate')
    if (response.status >= 200 && response.status < 300) {
      localStorage.setItem('accessToken', response.data.token)
      localStorage.setItem('mainDeptCode', response.data.mainDeptCode)
      localStorage.setItem('subDeptCode', response.data.subDeptCode)
      localStorage.setItem('roles', response.data.roles)
      yield put(setUserAdmin(response.data.roles))
      yield put(initializeSuccess(response.data.data))
      if (history !== undefined) {
        if (history.location.pathname === '/') {
          history.replace('/')
        }
      }
    } else {
      yield put(initializeFailure())
      localStorage.removeItem('accessToken')
      localStorage.removeItem('roles')
      localStorage.removeItem('mainDeptCode')
      localStorage.removeItem('subDeptCode')
      yield put(setUserAdmin(false))
      history.replace('/')
    }
    yield put(initializeSuccess())
  } catch (e) {
      console.log(e)
      yield put(console.log(`Error (${e.statusText})`, e.data.Errors[0]))
  }
}

function* showSuccessToast(action) {
  toast.clear()
  yield toast.show({ message: action.payload.message, intent: 'success', timeout: 5000 })
}

function* showWarningToast(action) {
  toast.clear()
  yield toast.show({ message: action.payload.message, intent: 'warning', timeout: 15000 })
}

function* showErrorToast(action) {
  toast.clear()
  yield toast.show({ message: action.payload.message, intent: 'danger', timeout: action.payload.isNoTimeout?0:15000 })
}

export function* watchApplicationSaga() {
  yield takeLatest(INITIALIZE.REQUEST, initializeApplication)
  yield takeLatest(TOAST_SUCCESS, showSuccessToast)
  yield takeLatest(TOAST_WARNING, showWarningToast)
  yield takeLatest(TOAST_ERROR, showErrorToast)
}

const updateCollapseMenu = (menus, index, subIndex) => {
  if (subIndex !== null && subIndex !== undefined) {
    menus[index].subMenus[subIndex].collapse = !menus[index].subMenus[subIndex].collapse
    if (menus[index].subMenus[subIndex].name === 'Company Buy') {
      localStorage.setItem('bgCompanyBuy', menus[index].subMenus[subIndex].collapse)
    }
  
    if (menus[index].subMenus[subIndex].name === 'Company Sale') {
      localStorage.setItem('bgCompanySale', menus[index].subMenus[subIndex].collapse)
    }
  } else {
    menus[index].collapse = !menus[index].collapse

    if (menus[index].name === 'Procurement System') {
      localStorage.setItem('procurementCollapse', menus[index].collapse)
    }

    if (menus[index].name === 'Legal System') {
      localStorage.setItem('legalCollapse', menus[index].collapse)
    }

    if (menus[index].name === 'Bank Guarantee') {
      localStorage.setItem('bankGuaranteeCollapse', menus[index].collapse)
    }
  }

  return [...menus]
}

export default createReducer(initial, state => ({
  [INITIALIZE.REQUEST]: () => ({
    ...state,
    loading: true
  }),
  [INITIALIZE.SUCCESS]: (data) => ({
    ...state,
    user: data.user,
    loading: false
  }),
  [INITIALIZE.FAILURE]: () => ({
    ...state,
    loading: false
  }),
  [APP_LOADING]: (data) => ({
    ...state, 
    loading: true,
    loadingMsg: data.message
  }),
  [APP_LOADED]: () => ({
    ...state, 
    loading: false,
    loadingMsg: ''
  }),
  [SHOW_SIDE_MENU]: () => ({
    ...state,
    showSideMenu: !state.showSideMenu
  }),
  [COLLAPSE_MENU]: () => ({
    ...state,
    collapseSideMenu: !state.collapseSideMenu
  }),
  [COLLAPSE_SUB_MENU]: (data) => ({
    ...state,
    menus: updateCollapseMenu(state.menus, data.index, data.subIndex)
  }),
  [SHOW_MODAL]: (data) => ({
    ...state,
    modal: { ...data }
  }),
  [SHOW_CONFIRM_MODAL]: (data) => ({
    ...state,
    confirmModal: { 
      ...data,
    }
  }),
  [SET_SHOW_MOBILE_MENU]: (data) => ({
    ...state,
    showMobileMenu: data.show
  })
}))